// Where the server products live in AMUI. One list of all the account's
// servers at /servers; each product under its own prefix:
//   /servers/vps/:id  — the KVM product (Prox Customer API)
//   /servers/mvm/:id  — the existing VPS product (billing service type "vserver")
// (Old /hosting/kvm/… and /hosting/vps/… URLs redirect here — see router/services.js.)

export const SERVERS_PATH = '/servers'
export const KVM_SERVER_BASE = '/servers/vps'
export const MVM_SERVER_BASE = '/servers/mvm'

/**
 * The base URL of a billing service's pages, by its route type ('shared',
 * 'reseller', 'vps', 'dedicated', 'kvm' — see SERVICE_ROUTE_TYPE_BY_SERVICE_TYPE):
 * servers under /servers, everything else under /hosting.
 */
export function serviceBasePath (routeType, id) {
  if (routeType === 'kvm') return `${KVM_SERVER_BASE}/${id}`
  if (routeType === 'vps') return `${MVM_SERVER_BASE}/${id}`
  return `/hosting/${routeType}/${id}`
}

/** The KVM area: the /servers list, ordering, and a KVM server's pages (not /servers/mvm). */
export function isKvmPath (path) {
  return /^\/servers(\/(order|vps(\/.*)?))?\/?$/.test(path || '')
}

/** One KVM server's own pages (they get the service sidebar). */
export function isKvmServerPath (path) {
  return /^\/servers\/vps\/[^/]+/.test(path || '')
}
